enum StatusEnvioDotz {
    NaoEnviado = 0,
    Enviado = 1,
    Erro = 2,
    Pendente = 3,
}

export default StatusEnvioDotz;
